import { SpaceJoinRequestStatus, } from '@tribeplatform/gql-client/types';
import { useMutation, useQueryClient } from '../../lib';
import { useTribeClient } from '../../useTribeClient';
import { getApproveSpaceMembershipRequestKey, getSpaceMembershipRequest, } from '../../utils/keys';
export const useApproveSpaceMembershipRequest = (options) => {
    const { useMutationOptions } = options || {};
    const { client } = useTribeClient();
    const queryClient = useQueryClient();
    return useMutation(variables => client.spaceMembership.approveRequest(variables), {
        mutationKey: getApproveSpaceMembershipRequestKey(),
        onSettled: (data, error, variables) => {
            const key = getSpaceMembershipRequest({
                spaceId: variables.spaceId,
                status: SpaceJoinRequestStatus.PENDING,
            });
            queryClient.invalidateQueries(key);
        },
        ...useMutationOptions,
    });
};
//# sourceMappingURL=useApproveSpaceMembershipRequest.js.map